import SessionEvent from 'session/SessionEvent.js';
import Tone from 'tone';
import {TRACK_MUTE} from 'session/constants.js';

class TrackMuteEvent extends SessionEvent {
    constructor(track, mute) {
        super();
        this.track= track;
        this.mute = mute;
    }

    getValue() {
        return this.mute ? 0 : 1;
    }

    isSkippable() {
        return false;
    }

    executeEvent(sequencerEngine) {
        this.subSequence.tracks[this.track.trackNumber].mute(this.mute, true);
    }

    getType() {
        return TRACK_MUTE;
    }

    getJson() {
        return { ... super.getJson(),
            trackNumber: this.track.trackNumber,
            mute: this.mute
        };
    }

    fromJson(json, sequencerEngine) {
        super.fromJson(json);
        this.track = sequencerEngine.tracks[json.trackNumber];
        this.mute = json.mute;
        return this;
    }
}

export default TrackMuteEvent;

